
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.475 16.332h-.667a2.666 2.666 0 01-2.666-2.667V11a2.667 2.667 0 012.666-2.667h.667A.666.666 0 015.141 9v6.666a.667.667 0 01-.666.667zm13.998 0h-.667a.666.666 0 01-.666-.667V9a.667.667 0 01.666-.667h.667A2.666 2.666 0 0121.139 11v2.666a2.667 2.667 0 01-2.666 2.667zM3.81 8.333A7.334 7.334 0 0111.142 1v0a7.331 7.331 0 017.332 7.333m-4.666 11.332h2A2.666 2.666 0 0018.474 17v-.667","stroke":"#5C6970","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M12.475 20.999h-1.333a1.333 1.333 0 010-2.667h1.333a1.333 1.333 0 010 2.667z","stroke":"#5C6970","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    